export class ResourceDetails {
    constructor() {
        this.image = undefined;
        this.uri = undefined;
        this.label = undefined;
        this.encodeURI = undefined;
        this.comment = undefined;
        this.context = undefined;
    }
}
